module.exports = __webpack_public_path__ + "img/bmxk@2x.cc837ef1.png";